// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { Decimal } from "decimal.js";
import { ConfigReducer } from "features/config/types";
import { toast, ToastOptions, TypeOptions } from "react-toastify";
import { api } from "./api";

const truncateRegex = /^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{4})$/;
export const truncateEthAddress = (address?: string) => {
  if (!address) return;
  const match = address.match(truncateRegex);

  if (!match) return address;
  return `${match[1]}...${match[2]}`;
};

export const optionsToastify: ToastOptions<{}> = {
  position: "top-center",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
  type: "info",
};

export const myToast = (text: string = "My toast...", type: TypeOptions = "info", timeAutoClose: number = 2000) => {
  return toast(text, { ...optionsToastify, type, autoClose: timeAutoClose });
};

export const decimalFormat = (number: string, decimal?: number): Decimal => {
  if (!number) return new Decimal("0");

  if (decimal === undefined) {
    decimal = 8;
  }

  const a = new Decimal(number);
  const b = Decimal.pow(10, -decimal);
  const c = a.mul(b);

  return c;
};

export const isCorrectNetwork = (networkNumber: number, config: ConfigReducer) => {
  let convertName = "";
  switch (networkNumber) {
    case 1:
      convertName = "Mainnet";
      break;
    case 2:
      convertName = "Testnet";
      break;
    default:
      convertName = "Devnet";
  }

  return convertName.toLowerCase() === config.base.NETWORK_NAME.toLowerCase();
};

export const isCorrectBlockchain = (networkType: string) => {
  return networkType.toLowerCase() === "aptos";
};

export const checkAddress = async ({ address }: { address: string }): Promise<boolean> => {
  try {
    const res = await api().get(`mainnet/membership/is-buyable/${address}`);
    if (res.status === 200) return true;
    return false;
  } catch (error) {
    return false;
  }
};

export const configModal = (borderColor: string = "#7f8c8d", borderWidth: number = 1) => {
  const style = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: 0,
      borderRadius: "24px",
      boxShadow: "0px 4px 71px #000",
      border: `${borderWidth}px solid ${borderColor}`,
      inset: "55% auto auto 50%",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.53)",
      backdropFilter: "blur(3px)",
      zIndex: 50,
    },
  };

  return style;
};
